<template>
  <div class="space-y-8">
    <div class="grid gap-3">
      <button 
        @click="select('handsOff')" 
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === 'handsOff' 
            ? 'btn-primary shadow-lg' 
            : 'btn-outline hover:bg-base-200'
        ]">
        {{ $t("smartLeadForm.involvement.options.handsOff") }}
      </button>
      <button 
        @click="select('collab')" 
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === 'collab' 
            ? 'btn-primary shadow-lg' 
            : 'btn-outline hover:bg-base-200'
        ]">
        {{ $t("smartLeadForm.involvement.options.collab") }}
      </button>
      <button 
        @click="select('diyHelp')" 
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === 'diyHelp' 
            ? 'btn-primary shadow-lg' 
            : 'btn-outline hover:bg-base-200'
        ]">
        {{ $t("smartLeadForm.involvement.options.diyHelp") }}
      </button>
    </div>

    <button 
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50" 
      :disabled="!selected" 
      @click="$emit('next')">
      {{ $t("smartLeadForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

// Safely extract and cast to string
const selected = ref(typeof props.modelValue.involvement === "string" ? props.modelValue.involvement : "");

watch(selected, val => {
  emit("update:modelValue", {
    ...props.modelValue,
    involvement: val,
  });
});

function select(val: string) {
  selected.value = val;
}
</script>
